import React from 'react';
var ProFormContext = /*#__PURE__*/React.createContext({});
export default ProFormContext;